/* eslint-disable max-params */
/**
 * getInfo fetches assets and creates a script tag pointing the entryKey
 * in assets collection.
 *
 * NOTE: This is expressed in a way that babel will not break up getInfo
 * so we use the same method in ReactDOM and ReactServerDOM.
 *
 * In detail: async/await are transpiled in such a way functions cannot
 * be serialized by direct reference
 * @param {object} props property bucket containing the below args
 * @param {string} props.url the url that points at the desired asset bucket
 * @param {string} props.entryKey the specific key of interest in the asset bucket
 * @param {string} props.nameSpace the name of the key where globals should be placed
 * @param {string} props.replaceSrcMethodName hooks for webpack
 * @param {function} props.onAssetsLoad function delegate when assets are found
 * @param {function} props.onLoad function delegate when script tag is loaded
 * @param {function} props.onError function delegate when an error occurs
  * @returns {function} promise that can be awaited for asset discovery
 */
export function getInfo(_ref) {
  var url = _ref.url,
    entryKey = _ref.entryKey,
    nameSpace = _ref.nameSpace,
    replaceSrcMethodName = _ref.replaceSrcMethodName,
    onAssetsLoad = _ref.onAssetsLoad,
    onLoad = _ref.onLoad,
    onError = _ref.onError;
  window[nameSpace] = window[nameSpace] || {};
  if (!window[nameSpace].assets) {
    var options = {
      method: 'POST',
      credentials: 'include'
    };
    window[nameSpace].assets = fetch(url, options).then(function (response) {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      return response.json();
    });
  }
  function renderScriptTag(src) {
    var body = document.getElementsByTagName('body')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = false;
    script.onload = onLoad;
    script.onerror = onError;
    script.crossOrigin = 'anonymous';
    body.appendChild(script);
    window[nameSpace][entryKey] = {
      isLoaded: true
    };
  }
  window[nameSpace].assets.then(function (assets) {
    var _window$nameSpace$ent;
    if (assets && !((_window$nameSpace$ent = window[nameSpace][entryKey]) !== null && _window$nameSpace$ent !== void 0 && _window$nameSpace$ent.isLoaded)) {
      onAssetsLoad === null || onAssetsLoad === void 0 ? void 0 : onAssetsLoad(assets);
      window[nameSpace][replaceSrcMethodName] = function (name) {
        return assets.buildAssets[name];
      };
      if (window.React) {
        renderScriptTag(assets.entries[entryKey]);
      } else {
        var interval = setInterval(function () {
          if (window.React) {
            clearInterval(interval);
            renderScriptTag(assets.entries[entryKey]);
          }
        }, 50);
      }
    }
  })["catch"](function (error) {
    onError && onError(error);
  });
  return window[nameSpace].assets;
}
//# sourceMappingURL=getInfo.js.map